/**
 * Main entry point for MEV-Med Frontend
 * Sets up React app with providers and global configuration
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import branding from './config/branding';
import './index.css';

// Ensure the document title has a fallback when env vars are not set
document.title = `${branding.appName} - ${branding.appDescription}`;

// Create root element
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Render app
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);